import { render, staticRenderFns } from "./transferenciaPlanificacion.vue?vue&type=template&id=1a6a273c&scoped=true"
import script from "./transferenciaPlanificacion.vue?vue&type=script&lang=js"
export * from "./transferenciaPlanificacion.vue?vue&type=script&lang=js"
import style0 from "./transferenciaPlanificacion.vue?vue&type=style&index=0&id=1a6a273c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6a273c",
  null
  
)

export default component.exports